// ----------------------------------------------------------------------

export const varHover = (hover = 1.09, tap = 0.97) => ({
    hover: { scale: hover },
    tap: { scale: tap },
})
